import React from 'react';
import type {CheckoutBrandModel} from '../../../domain/models/common/CheckoutBrand.model';
import {hexToRgbString} from '../../../domain/utils/colors';

export function getBrandStyle(checkoutBrand?: CheckoutBrandModel): React.CSSProperties {
  const formBackgroundColor = hexToRgbString(checkoutBrand?.formSection?.backgroundColor);
  const formTextColor = hexToRgbString(checkoutBrand?.formSection?.textColor);
  const tintedBoxColor = hexToRgbString(checkoutBrand?.global?.tintedBoxColor);
  const tintedBoxTextColor = hexToRgbString(checkoutBrand?.global?.tintedBoxTextColor);
  const cornerRadius = checkoutBrand?.global?.cornerRadius;
  const cornerRadiusValue = typeof cornerRadius === 'number' ? `${cornerRadius}` : undefined;

  return {
    '--headerBackground': checkoutBrand?.header?.backgroundFill?.color,
    '--headerTextColor-rgb': hexToRgbString(checkoutBrand?.header?.textColor),
    '--checkoutButtonColor': hexToRgbString(checkoutBrand?.global?.buttonColor),
    '--checkoutPlaceOrderButtonColor': hexToRgbString(checkoutBrand?.global?.placeOrderButtonColor),
    '--checkoutFormBackgroundColor': formBackgroundColor,
    '--checkoutSummaryBackgroundColor': hexToRgbString(checkoutBrand?.summarySection?.backgroundColor),
    '--checkoutButtonTextColor': hexToRgbString(checkoutBrand?.global?.buttonTextColor),
    '--checkoutPlaceOrderButtonTextColor': hexToRgbString(checkoutBrand?.global?.placeOrderButtonTextColor),
    '--checkoutFormTextColor': formTextColor,
    '--checkoutSummaryTextColor': hexToRgbString(checkoutBrand?.summarySection?.textColor),
    '--checkoutFormSecondaryTextColor': hexToRgbString(checkoutBrand?.formSection?.secondaryTextColor),
    '--checkoutSummarySecondaryTextColor': hexToRgbString(checkoutBrand?.summarySection?.secondaryTextColor),
    '--checkoutFooterBackgroundColor': hexToRgbString(checkoutBrand?.footer?.backgroundColor),
    '--checkoutFooterTextColor': hexToRgbString(checkoutBrand?.footer?.textColor),
    '--checkoutHeaderDividerColor': hexToRgbString(checkoutBrand?.header?.dividerColor),
    '--checkoutFooterDividerColor': hexToRgbString(checkoutBrand?.footer?.dividerColor),
    '--checkoutMainDividerColor': hexToRgbString(checkoutBrand?.mainDividerColor),
    '--checkoutTintedBoxColor': tintedBoxColor,
    '--checkoutTintedBoxTextColor': tintedBoxTextColor,
    '--checkoutSelectionColor': hexToRgbString(checkoutBrand?.global?.selectionColor),
    '--checkoutCornerRadius': cornerRadiusValue,
    '--deliveryMethodsCornerRadius': cornerRadiusValue,
    '--payments-co-border-radius': cornerRadiusValue,
    '--payments-ecw-background-color': formBackgroundColor,
    '--payments-ecw-text-color': formTextColor,
    '--payments-ecw-divider-color': hexToRgbString(checkoutBrand?.formSection?.expressButtonsBorderColor),
    '--payments-co-background-color': formBackgroundColor,
    '--payments-co-text-color': formTextColor,
    '--payments-co-method-box-background-color': tintedBoxColor,
    '--payments-co-method-box-text-color': tintedBoxTextColor,
    '--payments-co-method-box-icon-color': tintedBoxTextColor,
    '--payments-co-method-box-opacity': tintedBoxColor ? '1' : undefined,
    '--payments-co-method-box-border-radius': cornerRadiusValue,
    '--payments-co-cta-color': hexToRgbString(checkoutBrand?.global?.selectionColor),
  } as React.CSSProperties;
}
